import React, { Component } from 'react';
import Dropdown from '../CommonComponents/Dropdown';
import DatePicker from '../CommonComponents/DatePicker';
import _moment, { Moment } from 'moment';
import { extendMoment } from 'moment-range';

import { BASE_URL, HTTP_URL } from '../constants';

import FileDownloadIcon from '../assets/icons/file-download.svg';
import AnalyticsLoader from '../assets/icons/loader.svg';
import { Agent } from 'http';

type Props = {
  onClose: Function;
  backBtnIcon: any;
  isQueueRankingLoading: boolean;
  isAgentRankingLoading: boolean;
  setRankList?: {
    OverallRanking: {
      name: string;
      count: number;
      percentage?: number;
      chatHandledLaplace?: number;
      rank: number;
      chatHandled: number;
    }[];
    AnsweredHandoffs: {
      name: string;
      count: number;
      percentage?: number;
      chatHandledLaplace?: number;
      rank: number;
      chatHandled: number;
    }[];
    ResolvedHandoffs: {
      name: string;
      count: number;
      percentage?: number;
      chatHandledLaplace?: number;
      rank: number;
      chatHandled: number;
    }[];
    UnresolvedHandoffs: {
      name: string;
      count: number;
      percentage?: number;
      chatHandledLaplace?: number;
      rank: number;
      chatHandled: number;
    }[];
    AbandonedHandoffs: {
      name: string;
      count: number;
      percentage?: number;
      chatHandledLaplace?: number;
      rank: number;
      chatHandled: number;
    }[];
    UserFeedback: {
      name: string;
      count: number;
      percentage?: number;
      chatHandledLaplace?: number;
      rank: number;
      chatHandled: number;
    }[];
    AvgAgentResponseTime: {
      name: string;
      count: number;
      percentage?: number;
      chatHandledLaplace?: number;
      rank: number;
      chatHandled: number;
    }[];
  };
  setqueueRankList?: {
    OverallRanking: {
      name: string;
      count: number;
      percentage?: number;
      queueCountLaplace?: number;
      rank: number;
    }[];
    NoofHandoffs: {
      name: string;
      count: number;
      percentage?: number;
      queueCountLaplace?: number;
      rank: number;
    }[];
    AnsweredHandoffs: {
      name: string;
      count: number;
      percentage?: number;
      queueCountLaplace?: number;
      rank: number;
    }[];
    ResolvedHandoffs: {
      name: string;
      count: number;
      percentage?: number;
      queueCountLaplace?: number;
      rank: number;
    }[];
    UnresolvedHandoffs: {
      name: string;
      count: number;
      percentage?: number;
      queueCountLaplace?: number;
      rank: number;
    }[];
    UnansweredHandoffs: {
      name: string;
      count: number;
      percentage?: number;
      queueCountLaplace?: number;
      rank: number;
    }[];
    AbandonedHandoffs: {
      name: string;
      count: number;
      percentage?: number;
      queueCountLaplace?: number;
      rank: number;
    }[];
    userFeedback: {
      name: string;
      count: number;
      percentage?: number;
      queueCountLaplace?: number;
      rank: number;
    }[];
    AvgUserWaitTimeinQueue: {
      name: string;
      count: number;
      percentage?: number;
      queueCountLaplace?: number;
      rank: number;
    }[];
  };
  source: string;
  selectedbotIcon: string;
  selectedbotName: string;
  setRankingCompleteList?: Function;
  startDate: Moment;
  endDate: Moment;
  utcstartDate: any;
  utcendDate: any;
  dateSelection: Function;
  selectedFilter: { name: string; id: number };
  botID: string;
  channelSource: string;
  deviceInfo?: string;
  downloadToaterNotify: Function;
  realTimeAgentList?: {
    Name: string;
    EmailId: string;
    RoleName: string;
  }[];
};
type State = {
  selectedAgentRanking: { name: string; id: number };
  agentRankingList: { name: string; id: number }[];
  selectedQueueRanking: { name: string; id: number };
  queueRankingList: { name: string; id: number }[];
};
export default class RankingList extends Component<Props, State> {
  // moment = extendMoment(_moment);
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();

    this.downloadReport = this.downloadReport.bind(this);
  }
  setInitialState(): State {
    return {
      selectedAgentRanking: {
        name: 'Answered Handoffs',
        id: 0,
      },
      agentRankingList: [
        // { name: 'Overall Performance', id: 0 },
        { name: 'Answered Handoffs', id: 1 },
        { name: 'Resolved Handoffs', id: 2 },
        { name: 'Unresolved Handoffs', id: 3 },
        { name: 'Abandoned Handoffs', id: 4 },
        { name: 'User Feedback', id: 5 },
        { name: 'Avg. Agent Response Time', id: 6 },
      ],
      selectedQueueRanking: {
        name: 'No. of Handoffs',
        id: 0,
      },
      queueRankingList: [
        // { name: 'Overall Performance', id: 0 },
        { name: 'No. of Handoffs', id: 1 },
        { name: 'Answered Handoffs', id: 2 },
        { name: 'Resolved Handoffs', id: 3 },
        { name: 'Unresolved Handoffs', id: 4 },
        { name: 'Abandoned Handoffs', id: 5 },
        { name: 'Unanswered Handoffs', id: 6 },
        { name: 'User Feedback', id: 7 },
        { name: 'Avg. User Wait Time in Queue', id: 8 },
      ],
    };
  }
  selectAgentRanking(index: number | undefined) {
    this.setState(
      {
        selectedAgentRanking:
          typeof index === 'number'
            ? this.state.agentRankingList[index]
            : { name: '', id: -1 },
      },
      () => {
        if (typeof index === 'number')
          this.props.setRankingCompleteList &&
            this.props.setRankingCompleteList(
              this.state.agentRankingList[index].name,
              this.state.agentRankingList[index]
            );
      }
    );
  }
  selectQueueRanking(index: number | undefined) {
    this.setState(
      {
        selectedQueueRanking:
          typeof index === 'number'
            ? this.state.queueRankingList[index]
            : { name: '', id: -1 },
      },
      () => {
        if (typeof index === 'number')
          this.props.setRankingCompleteList &&
            this.props.setRankingCompleteList(
              this.state.queueRankingList[index].name,
              this.state.queueRankingList[index]
            );
      }
    );
  }
  get List() {
    let name = this.state.selectedAgentRanking.name;
    if (this.props.setRankList) {
      if (name === 'Answered Handoffs') {
        return this.props.setRankList.AnsweredHandoffs.sort((agent1, agent2) =>
          agent2.percentage && agent1.percentage
            ? agent2.percentage - agent1.percentage
            : agent2.count - agent1.count
        );
      } else if (name === 'Resolved Handoffs') {
        return this.props.setRankList.ResolvedHandoffs.sort((agent1, agent2) =>
          agent2.count && agent1.count
            ? agent2.count - agent1.count
            : agent2.rank - agent1.rank
        );
      } else if (name === 'Unresolved Handoffs') {
        return this.props.setRankList.UnresolvedHandoffs.sort((agent1, agent2) =>
          agent2.count && agent1.count
            ? agent2.count - agent1.count
            : agent2.rank - agent1.rank
        );
      } else if (name === 'Abandoned Handoffs') {
        return this.props.setRankList.AbandonedHandoffs.sort((agent1, agent2) =>
          agent2.count && agent1.count
            ? agent2.count - agent1.count
            : agent2.rank - agent1.rank
        );
      } else if (name === 'User Feedback') {
        return this.props.setRankList.UserFeedback.sort(
          (agent1, agent2) => agent2.count - agent1.count
        );
      } else if (name === 'Avg. Agent Response Time') {
        return this.props.setRankList.AvgAgentResponseTime.sort((agent1, agent2) => {
          if (agent2.chatHandled && agent1.chatHandled) {
            return agent1.chatHandled - agent2.chatHandled;
          } else {
            return agent2.chatHandled - agent1.chatHandled;
          }
        });
      } else if (name === 'Overall Performance') {
        return this.props.setRankList.OverallRanking.sort(
          (agent1, agent2) => agent2.count - agent1.count
        );
      }
    }
  }
  get queueList() {
    // console.log(this.props.setqueueRankList && this.props.setqueueRankList.NoofHandoffs.sort(
    //       (agent1, agent2) => agent2.count - agent1.count
    //     ));
    let name = this.state.selectedQueueRanking.name;
    if (this.props.setqueueRankList) {
      if (name === 'No. of Handoffs') {
        return this.props.setqueueRankList.NoofHandoffs.sort(
          (agent1, agent2) => agent2.count - agent1.count
        );
      } else if (name === 'Answered Handoffs') {
        return this.props.setqueueRankList.AnsweredHandoffs.sort((agent1, agent2) =>
          agent2.count && agent1.count
            ? agent2.count - agent1.count
            : agent2.rank - agent1.rank
        );
      } else if (name === 'Resolved Handoffs') {
        return this.props.setqueueRankList.ResolvedHandoffs.sort((agent1, agent2) =>
          agent2.count && agent1.count
            ? agent2.count - agent1.count
            : agent2.rank - agent1.rank
        );
      } else if (name === 'Unresolved Handoffs') {
        return this.props.setqueueRankList.UnresolvedHandoffs.sort((agent1, agent2) =>
          agent2.count && agent1.count
            ? agent2.count - agent1.count
            : agent2.rank - agent1.rank
        );
      } else if (name === 'User Feedback') {
        return this.props.setqueueRankList.userFeedback.sort(
          (agent1, agent2) => agent2.count - agent1.count
        );
      } else if (name === 'Avg. User Wait Time in Queue') {
        return this.props.setqueueRankList.AvgUserWaitTimeinQueue.sort(
          (agent1, agent2) => {
            if (agent2.count === -100 || agent1.count === -100) {
              return agent2.count - agent1.count;
            } else {
              return agent1.count - agent2.count;
            }
          }
        );
      } else if (name === 'Abandoned Handoffs') {
        return this.props.setqueueRankList.AbandonedHandoffs.sort((agent1, agent2) =>
          agent2.count && agent1.count
            ? agent2.count - agent1.count
            : agent2.rank - agent1.rank
        );
      } else if (name === 'Unanswered Handoffs') {
        return this.props.setqueueRankList.UnansweredHandoffs.sort((agent1, agent2) =>
          agent2.count && agent1.count
            ? agent2.count - agent1.count
            : agent2.rank - agent1.rank
        );
      } else if (name === 'Overall Performance') {
        return this.props.setqueueRankList.OverallRanking.sort((agent1, agent2) =>
          agent2.count && agent1.count
            ? agent2.count - agent1.count
            : agent2.rank - agent1.rank
        );
      }
    }
  }
  convertSecondstoTime(secs: number) {
    // given_seconds = 3685;

    let dateObj = new Date(secs * 1000);
    let minutes = dateObj.getUTCMinutes();
    let seconds = dateObj.getSeconds();

    let timeString =
      minutes.toString().padStart(2, '0') +
      ' min ' +
      seconds.toString().padStart(2, '0') +
      ' sec ';

    return timeString;
  }
  componentDidMount() {
    if (this.props.selectedFilter) {
      if (this.props.source === 'agent') {
        this.setState(
          {
            selectedAgentRanking: {
              name: this.props.selectedFilter.name,
              id: this.props.selectedFilter.id,
            },
          },
          () => {
            this.props.setRankingCompleteList &&
              this.props.setRankingCompleteList(this.props.selectedFilter.name);
          }
        );
      } else {
        this.setState(
          {
            selectedQueueRanking: {
              name: this.props.selectedFilter.name,
              id: this.props.selectedFilter.id,
            },
          },
          () => {
            this.props.setRankingCompleteList &&
              this.props.setRankingCompleteList(this.props.selectedFilter.name);
          }
        );
      }
    }
  }
  downloadReport() {
    let datachannel = '';
    if (this.props.channelSource.indexOf('Web') > -1) {
      datachannel = 'webs';
    } else if (this.props.channelSource === 'WhatsApp') {
      datachannel = 'whatsapp';
    } else {
      datachannel = this.props.channelSource;
    }
    // this.props.channelSource
    fetch(
      `${HTTP_URL}${BASE_URL}/GetAllAgentReport?start=${
        this.props.utcstartDate //uat
        // `https://${BASE_URL}/GetAllAgentReport?start=${this.props.utcstartDate
      }&end=${this.props.utcendDate}&channel=${datachannel}&deviceInfo=${
        this.props.deviceInfo
      }&botId=${encodeURIComponent(
        this.props.botID
      )}&agentSessionID=${sessionStorage.getItem('agentActiveSession')}`,
      {
        method: 'GET',
      }
    )
      .then((response) => response.blob())
      .then((blob) => {
        this.props.downloadToaterNotify('Your download will start in a few seconds');
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `report_${new Date().getTime()}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  }
  render() {
    return (
      <div>
        <div className='agent-ranking-header'>
          <div
            onClick={() => {
              this.props.onClose();
            }}
            className='bac-to-prev-screen'>
            <img src={this.props.backBtnIcon} alt='backicon' />
            Back
          </div>
          <div className='agent-ranking-sub-header'>
            {this.props.source === 'agent' ? (
              <>
                <div style={{ marginLeft: '19px' }}>Agent Rankings</div>
              </>
            ) : this.props.source === 'RealTime' ? (
              <>
                <div style={{ marginLeft: '19px' }}>Agents Online List</div>
              </>
            ) : (
              <>
                <div style={{ marginLeft: '19px' }}>Queue Rankings</div>
              </>
            )}
            {this.props.selectedbotName && this.props.selectedbotIcon && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginRight: '24px',
                }}>
                <img
                  src={this.props.selectedbotIcon}
                  alt='botIcon'
                  style={{ width: '46px', height: '46px', marginRight: '10px' }}
                />
                <div>{this.props.selectedbotName}</div>
              </div>
            )}
          </div>
        </div>
        <div
          style={{
            overflowY: 'auto',
            height: 'calc(100vh - 154px)',
            marginLeft: '30px',
          }}>
          <div className='filter-download-area'>
            {this.props.source !== 'RealTime' ? (
              <div
                style={{
                  display: 'flex',
                  margin: '22px 0',
                  justifyContent: 'space-between',
                  width: '566px',
                }}>
                <>
                  <div
                    style={{
                      fontSize: '14px',
                      display: 'flex',
                      alignItems: 'center',
                      fontWeight: 'normal',
                      letterSpacing: '-0.21px',
                      whiteSpace: 'nowrap',
                    }}>
                    Rank By:
                  </div>
                  {this.props.source === 'agent' ? (
                    <Dropdown
                      selected={this.state.selectedAgentRanking.name}
                      options={this.state.agentRankingList.map(
                        (agentRank) => agentRank.name
                      )}
                      placeholder='Select agent ranking'
                      onSelectionChange={this.selectAgentRanking.bind(this)}
                      filterType='external'
                      fromAnalytics='true'
                      ranking='true'
                    />
                  ) : (
                    <Dropdown
                      selected={this.state.selectedQueueRanking.name}
                      options={this.state.queueRankingList.map(
                        (queueRank) => queueRank.name
                      )}
                      placeholder='Select queue ranking'
                      onSelectionChange={this.selectQueueRanking.bind(this)}
                      filterType='external'
                      fromAnalytics='true'
                      ranking='true'
                    />
                  )}
                </>

                <div style={{ marginLeft: '14px', marginTop: '5px' }}>
                  <DatePicker
                    onDateSelection={(start: Moment, end: Moment, selected?: string) => {
                      this.props.dateSelection(
                        start,
                        end,
                        this.props.source === 'agent'
                          ? this.state.selectedAgentRanking.name
                          : this.state.selectedQueueRanking.name,
                        this.props.source,
                        selected
                      );
                    }}
                    startDate={this.props.startDate}
                    endDate={this.props.endDate}
                    fromRanking='true'
                    notificationToaster={this.props.downloadToaterNotify}
                  />
                </div>
              </div>
            ) : null}
            {this.props.source === 'agent' ? (
              <div
                className='download-icon'
                title='Download data'
                onClick={this.downloadReport}>
                <img src={FileDownloadIcon} alt='Report Download' />
              </div>
            ) : null}
          </div>
          {this.props.isQueueRankingLoading || this.props.isAgentRankingLoading ? (
            // || this.state.isdataLoading
            <div
              className='agent-ranking-loader'
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                marginTop: '24px',
                maxWidth: '640px',
              }}>
              <img src={AnalyticsLoader} alt='loader' />
            </div>
          ) : (
            <>
              {(this.List && this.List.length > 0) ||
              (this.queueList && this.queueList.length > 0) ? (
                <div
                  className='rank-card'
                  style={
                    this.props.source === 'RealTime'
                      ? { maxWidth: '700px', boxShadow: 'none' }
                      : { maxWidth: '566px', boxShadow: 'none' }
                  }>
                  <div className='rank-card-header' style={{ display: 'flex' }}>
                    {this.props.source === 'agent' ? (
                      <>
                        <div
                          style={{
                            width: '0%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                          }}>
                          Rank
                        </div>
                        <div
                          style={{
                            width: '40%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                          }}>
                          Agents
                        </div>
                        <div
                          style={{
                            width: '40%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                          }}>
                          {this.state.selectedAgentRanking.name === 'User Feedback'
                            ? 'User Feedback (Positive)'
                            : this.state.selectedAgentRanking.name ===
                              'Overall Performance'
                            ? 'Score (Percentage)'
                            : this.state.selectedAgentRanking.name}
                        </div>
                      </>
                    ) : this.props.source === 'RealTime' ? (
                      <>
                        <div
                          style={{
                            width: '15%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                          }}>
                          S.NO
                        </div>
                        <div
                          style={{
                            width: '20%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                          }}>
                          Name
                        </div>
                        <div
                          style={{
                            width: '48%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                          }}>
                          Email Id
                        </div>
                        <div
                          style={{
                            width: '17%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                          }}>
                          Role
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          style={{
                            width: '0%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                          }}>
                          Rank
                        </div>
                        <div
                          style={{
                            width: '40%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                          }}>
                          Queue
                        </div>
                        <div
                          style={{
                            width: '40%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                          }}>
                          {this.state.selectedQueueRanking.name === 'User Feedback'
                            ? 'User Feedback (Positive)'
                            : this.state.selectedQueueRanking.name ===
                              'Overall Performance'
                            ? 'Score (Percentage)'
                            : this.state.selectedQueueRanking.name}
                        </div>
                      </>
                    )}
                  </div>
                  <div className='rank-card-content'>
                    {this.props.source === 'agent'
                      ? this.List &&
                        this.List.map((agent, index) => {
                          var averageAgentRespTime = '';
                          if (
                            this.state.selectedAgentRanking.name ===
                            'Avg. Agent Response Time'
                          ) {
                            agent.chatHandled === 0
                              ? (averageAgentRespTime = '-')
                              : (averageAgentRespTime = this.convertSecondstoTime(
                                  agent.chatHandled
                                ));
                          }
                          return (
                            <div
                              key={index}
                              className='row on-hover'
                              style={{ display: 'flex' }}>
                              <div
                                style={{
                                  color: 'black',
                                  width: '10%',
                                  display: 'flex',
                                  justifyContent: 'flex-start',
                                }}>
                                {this.state.selectedAgentRanking.name ===
                                'Avg. Agent Response Time'
                                  ? averageAgentRespTime === '-'
                                    ? '-'
                                    : index + 1
                                  : agent.rank === -1
                                  ? '-'
                                  : agent.rank}
                              </div>
                              <div
                                style={{
                                  width: '50%',
                                  display: 'flex',
                                  justifyContent: 'flex-start',
                                  color: 'black',
                                  wordBreak: 'break-word',
                                  wordWrap: 'break-word',
                                }}>
                                {agent.name}
                              </div>
                              {this.state.selectedAgentRanking.name ===
                              'Answered Handoffs' ? (
                                <div
                                  style={{
                                    width: '40%',
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                  }}>
                                  {' '}
                                  {agent.percentage === -100 ? '-' : agent.percentage}
                                </div>
                              ) : this.state.selectedAgentRanking.name ===
                                  'Resolved Handoffs' ||
                                this.state.selectedAgentRanking.name ===
                                  'Unresolved Handoffs' ||
                                this.state.selectedAgentRanking.name ===
                                  'Abandoned Handoffs' ? (
                                <div
                                  style={{
                                    width: '40%',
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                  }}>
                                  {agent.count === -100 && agent.percentage === -100 ? (
                                    '-'
                                  ) : (
                                    <>
                                      {agent.count + '%'}
                                      <span style={{ marginLeft: '5px' }}>
                                        {' '}
                                        ({agent.percentage && agent.percentage})
                                      </span>
                                    </>
                                  )}
                                </div>
                              ) : this.state.selectedAgentRanking.name ===
                                  'Overall Performance' ||
                                this.state.selectedAgentRanking.name.indexOf(
                                  'User Feedback'
                                ) > -1 ? (
                                <div
                                  style={{
                                    width: '40%',
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                  }}>
                                  {' '}
                                  {agent.count === -100 ? '-' : agent.count + '%'}
                                </div>
                              ) : (
                                <div
                                  style={{
                                    width: '40%',
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                  }}>
                                  {averageAgentRespTime && averageAgentRespTime}
                                </div>
                              )}
                            </div>
                          );
                        })
                      : this.props.source === 'RealTime'
                      ? this.props.realTimeAgentList &&
                        this.props.realTimeAgentList.map((value: any, index: number) => {
                          return (
                            <div
                              key={index}
                              className='row on-hover'
                              style={{ display: 'flex' }}>
                              <div
                                style={{
                                  width: '15%',
                                  display: 'flex',
                                  justifyContent: 'flex-start',
                                }}>
                                {' '}
                                {index + 1}
                              </div>
                              <div
                                style={{
                                  width: '20%',
                                  display: 'flex',
                                  justifyContent: 'flex-start',
                                }}>
                                {' '}
                                {value.Name}
                              </div>
                              <div
                                style={{
                                  width: '48%',
                                  display: 'flex',
                                  justifyContent: 'flex-start',
                                }}>
                                {' '}
                                {value.EmailId}
                              </div>
                              <div
                                style={{
                                  width: '17%',
                                  display: 'flex',
                                  justifyContent: 'flex-start',
                                }}>
                                {' '}
                                {value.RoleName}
                              </div>
                            </div>
                          );
                        })
                      : this.queueList &&
                        this.queueList.map((queue, index) => {
                          var averageUserWaitTimeInQueue = '';
                          // console.log(queue);
                          if (
                            this.state.selectedQueueRanking.name ===
                            'Avg. User Wait Time in Queue'
                          ) {
                            queue.count === 0 || queue.count === -100
                              ? (averageUserWaitTimeInQueue = '-')
                              : (averageUserWaitTimeInQueue = this.convertSecondstoTime(
                                  queue.count
                                ));
                          }
                          if (queue.name.indexOf('deleted') > -1) {
                            return '';
                          }
                          return (
                            <div key={index} className='row' style={{ display: 'flex' }}>
                              <div
                                style={{
                                  color: 'black',
                                  width: '10%',
                                  display: 'flex',
                                  justifyContent: 'flex-start',
                                }}>
                                {this.state.selectedQueueRanking.name ===
                                  'Avg. User Wait Time in Queue' ||
                                this.state.selectedQueueRanking.name === 'No. of Handoffs'
                                  ? queue.count === -100
                                    ? '-'
                                    : index + 1
                                  : queue.rank === -1
                                  ? '-'
                                  : queue.rank}
                              </div>
                              <div
                                style={{
                                  width: '50%',
                                  display: 'flex',
                                  justifyContent: 'flex-start',
                                  color: 'black',
                                }}>
                                {queue.name}
                              </div>

                              {this.state.selectedQueueRanking.name ===
                                'Answered Handoffs' ||
                              this.state.selectedQueueRanking.name ===
                                'Unanswered Handoffs' ||
                              this.state.selectedQueueRanking.name ===
                                'Resolved Handoffs' ||
                              this.state.selectedQueueRanking.name ===
                                'Unresolved Handoffs' ||
                              this.state.selectedQueueRanking.name ===
                                'Abandoned Handoffs' ? (
                                <div
                                  style={{
                                    width: '40%',
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                  }}>
                                  {queue.count === -100 && queue.percentage === -100 ? (
                                    '-'
                                  ) : (
                                    <>
                                      {queue.count + '%'}
                                      <span style={{ marginLeft: '5px' }}>
                                        {' '}
                                        ({queue.percentage && queue.percentage})
                                      </span>
                                    </>
                                  )}
                                </div>
                              ) : this.state.selectedQueueRanking.name ===
                                'No. of Handoffs' ? (
                                <div>{queue.count === -100 ? '-' : queue.count}</div>
                              ) : this.state.selectedQueueRanking.name ===
                                  'Overall Performance' ||
                                this.state.selectedQueueRanking.name ===
                                  'User Feedback' ? (
                                <div>
                                  {queue.count === -100 ? '-' : queue.count + '%'}
                                </div>
                              ) : (
                                <div
                                  style={{
                                    width: '40%',
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                  }}>
                                  {averageUserWaitTimeInQueue &&
                                    averageUserWaitTimeInQueue}
                                </div>
                              )}
                            </div>
                          );
                        })}
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    fontSize: '14px',
                    lineHeight: '1.29',
                    color: 'rgba(0,0,0,0.4)',
                  }}>
                  No data to display
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}
